import React from "react"

import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"

const InfoBox = ({ content }) => {
  const allInfoBlocks = content.infoBlocks.map(block => (
    <InfoBlock>
      {block?.stat && <Stat>{block.stat}</Stat>}
      {block?.bodyCopy && <Body>{block.bodyCopy}</Body>}
      {block?.source && <Source>{block.source}</Source>}
    </InfoBlock>
  ))
  return (
    <Wrapper>
      {content?.introHeader && <IntroHeader>{content.introHeader}</IntroHeader>}
      <InfoMainDiv intro={content?.introHeader}>{allInfoBlocks}</InfoMainDiv>
    </Wrapper>
  )
}

const Source = styled.p`
  ${text.bodySmBold};
  color: ${colors.grey600};
`
const Body = styled.p`
  ${text.bodySmBold};
`
const Stat = styled.p`
  ${text.stat};
  color: ${colors.primaryOrange};
`
const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1.389vw;

  ${media.fullWidth} {
    gap: 20px;
  }

  ${media.tablet} {
    gap: 1.953vw;
  }

  ${media.mobile} {
    gap: 4.673vw;
  }
`
const InfoMainDiv = styled.div`
  background-color: ${colors.lightPurpleGrey};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: ${props => (props.intro ? "0 0 1.389vw 1.389vw" : "1.389vw")};
  gap: 2.778vw;
  width: 79.444vw;
  height: 15.278vw;
  padding: 0 10.278vw;

  ${media.fullWidth} {
    border-radius: ${props => (props.intro ? "0 0 20px 20px" : "20px")};
    gap: 40px;
    width: 1144px;
    height: 220px;
    padding: 0 148px;
  }

  ${media.tablet} {
    border-radius: ${props =>
      props.intro ? "0 0 1.953vw 1.953vw" : "1.953vw"};
    gap: 3.906vw;
    width: 92.09vw;
    height: 21.484vw;
    padding: 0 3.906vw;
  }

  ${media.mobile} {
    flex-direction: column;
    height: auto;
    width: 93.925vw;
    border-radius: ${props =>
      props.intro ? "0 0 4.673vw 4.673vw" : "4.673vw"};
    padding: 9.346vw 6.075vw;
    gap: 9.346vw;
  }
`
const IntroHeader = styled.div`
  ${text.h5};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.primaryPurple};
  color: ${colors.white};
  border-radius: 1.389vw 1.389vw 0 0;
  padding: 1.111vw 0;

  ${media.fullWidth} {
    border-radius: 20px 20px 0 0;
    padding: 16px 0;
  }

  ${media.tablet} {
    border-radius: 1.953vw 1.953vw 0 0;
    padding: 1.563vw 0;
  }

  ${media.mobile} {
    ${text.h4};
    border-radius: 4.673vw 4.673vw 0 0;
    padding: 3.738vw 0;
  }
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.389vw 0;

  ${media.fullWidth} {
    padding: 20px 0;
  }

  ${media.tablet} {
    padding: 1.953vw 0;
  }

  ${media.mobile} {
    padding: 4.673vw 0;
    align-items: center;
  }
`
export default InfoBox

